module.exports = __webpack_public_path__ + "static/media/viinilehti.b7cc89ca.svg";